import React from "react";

function SvgIcMapPoi123(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.866 14.035L18.6 17.302 14.7 13.403l3.267-3.267-1.949-1.949-7.834 7.833 1.95 1.95 3.267-3.267 3.898 3.9-3.267 3.265 1.95 1.95 7.833-7.834-1.949-1.949zM16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5m0 2c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi123;
